import { render } from "./TermsAndConditionsDialog.vue?vue&type=template&id=7b340a2c&scoped=true"
import script from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"

import "./TermsAndConditionsDialog.vue?vue&type=style&index=0&id=7b340a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b340a2c"]])

export default __exports__